import React from "react";
import { Col } from "antd";
import moment from "moment";
import {
  DataValue,
  DataHeading,
  UnderlineLink,
  DataDescription
} from "../CommonComponents/commonStyles";
import recurringIcon from "../assets/icons/recurring.svg";
import "../Epics/AccountSummary/Pages/AccountSummary.css";

export function renderTitleGrid({
  data,
  each,
  label,
  index,
  linkUrl,
  comingSoon,
  handleTitleClick
}) {
  return (
    <Col lg={24} md={24} className={index !== 0 ? "mt-xs-invest20" : "mt0"} data-test ="container">
      {comingSoon ? (
        <span className="tool-tip">
          <UnderlineLink weight="normal">
            {label}: {data[each]}
            {data.isRecurring === "true" ? (
              <img src={recurringIcon} className="cursor-auto ml2" />
            ) : (
              <div />
            )}
          </UnderlineLink>
          <span>
            <span className="tooltiptext-i">Coming Soon...</span>
          </span>
        </span>
      ) : (
        <UnderlineLink onClick={handleTitleClick} weight="normal" data-test ="underline-link" noDecaration={data.exchangetype.includes("Low Carbon Global Equity")}>
          {label}: {data[each]}
          {data.isRecurring === "true" ? (
            <img src={recurringIcon} className="cursor-auto ml2" />
          ) : (
            <div />
          )}
        </UnderlineLink>
      )}
    </Col>
  );
}

export function renderGrantDateGrid({ data, each, label, mtop }) {
  return (
    <Col lg={8} md={12} className={mtop === true ? "mt1" : "mt0"} data-test="container">
      <DataHeading className="mt-20">{label}</DataHeading>
      {data[each] !== null ? (
        <DataValue className="mt0">{moment(data[each]).format("L")}</DataValue>
      ) : (
        <DataValue> &mdash; </DataValue>
      )}
    </Col>
  );
}

export function renderGrantAmountGrid1({ data, each, label, mtop }) {
  return (
    <Col
      lg={8}
      md={24}
      className={mtop === true ? "mt1 tab-fix" : "mt0 tab-fix"}
      data-test="container"
    >
      <DataHeading className="mt-20">{label}</DataHeading>
      {data[each] == 0 ? (
        <DataValue> &mdash; </DataValue>
      ) : data[each] !== null ? (
        <DataValue className="mt0">
          {"$" +
            Number(data[each]).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}
        </DataValue>
      ) : (
        <DataValue> &mdash; </DataValue>
      )}
    </Col>
  );
}

export function renderDescriptionGrid({ data, each, label, index }) {
  return data[each] !== null && data[each].length !== 0 ? (
    <Col
      lg={24}
      md={24}
      className={index !== 0 ? "mt-xs-invest20 tab-fix" : "mt0 tab-fix"}
      data-test="grantsDashboardDescriprion"
    >
      <DataDescription>{data[each]}</DataDescription>
    </Col>
  ) : null;
}

export function renderDateGrid({ data, each, label, mtop }) {
  return (
    <Col lg={8} md={12} className={mtop === true ? "mt1" : "mt0"} data-test="container">
      <DataHeading className="mt-20">{label}</DataHeading>
      {data[each] !== null ? (
        <DataValue className="mt0">
          {moment(moment.tz(data[each], "America/New_York")).format("L")}
        </DataValue>
      ) : (
        <DataValue> &mdash; </DataValue>
      )}
    </Col>
  );
}

export function renderContributionsDateGrid({ data, each, label, mtop }) {
  return (
    <Col
      lg={8}
      md={12}
      className={mtop === true ? "mt1 tab-fix" : "mt0 tab-fix"}
      data-test="container"
    >
      <DataHeading className="mt-20">{label}</DataHeading>
      {data[each] !== null && data[each] !== undefined ? (
        <DataValue className="mt0">
          {label === "Received date" ? (
            data.type === "Special Asset" && data.status === "Entered" ? (
              <>&mdash;</>
            ) : (
              moment.tz(moment(data[each]), "America/New_York").format("L")
            )
          ) : (
            moment.tz(moment(data[each]), "America/New_York").format("L")
          )}
        </DataValue>
      ) : (
        <DataValue> &mdash; </DataValue>
      )}
    </Col>
  );
}

export function renderAmountGrid({ data, each, label, mtop }) {
  return (
    <Col lg={8} md={12} className={mtop === true ? "mt1" : "mt0"} data-test="container">
      <DataHeading className="mt-20">{label}</DataHeading>
      {data[each] !== null ? (
        <DataValue className="mt0">
          {"$" +
            Number(data[each]).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}
        </DataValue>
      ) : (
        <DataValue> &mdash; </DataValue>
      )}
    </Col>
  );
}

export function renderFixGrid({ data, each, label, mtop }) {
  return (
    <Col lg={8} md={12} className={mtop === true ? "mt1" : "mt0"} data-test="container">
      <DataHeading className="mt-20">{label}</DataHeading>
      {data[each] === "" || data[each] === null ? (
        <DataValue> &mdash; </DataValue>
      ) : (
        <DataValue className="mt0">
          {each === "status.extDescription"
            ? data.status.extDescription
            : data[each] === "SHARE"
            ? "Units"
            : typeof data[each] === "string"
            ? data[each].charAt(0).toUpperCase() +
              data[each].slice(1).toLowerCase()
            : data[each] === "amount"
            ? `$${data[each]}`
            : data[each]}
        </DataValue>
      )}
    </Col>
  );
}

export function renderDashboardFixGrid({ data, each, label, mtop }) {
  return (
    <Col
      lg={8}
      md={24}
      className={mtop === true ? "mt1 tab-fix" : "mt0 tab-fix"}
      data-test = "container"
    >
      <DataHeading className="mt-20">{label}</DataHeading>
      {data[each] === "" || data[each] === null ? (
        <DataValue> &mdash; </DataValue>
      ) : (
        <DataValue className="mt0">
          {each === "status.extDescription"
            ? data.status.extDescription
            : data[each] === "SHARE"
            ? "Units"
            : each === "status"
            ? data[each]
            : typeof data[each] === "string"
            ? data[each].charAt(0).toUpperCase() +
              data[each].slice(1).toLowerCase()
            : data[each] === "amount"
            ? `$${data[each]}`
            : data[each] === "noOfShares"
            ? `${data[each]}`
            : data[each]}
        </DataValue>
      )}
    </Col>
  );
}

export function renderDateGrid1({ data, each, label, mtop }) {
  return (
    <Col lg={6} md={12} className={mtop === true ? "mt1" : "mt0"}>
      <DataHeading className="mt-20">{label}</DataHeading>
      {data[each] !== null ? (
        <DataValue className="mt0">
          {moment(moment.tz(data[each], "America/New_York")).format("L")}
        </DataValue>
      ) : (
        <DataValue> &mdash; </DataValue>
      )}
    </Col>
  );
}

export function renderAmountGrid1({ data, each, label, mtop }) {
  return (
    <Col
      lg={6}
      md={12}
      className={mtop === true ? "mt1 tab-fix" : "mt0 tab-fix"}
      data-test="container"
    >
      <DataHeading className="mt-20">{label}</DataHeading>
      {data[each] == 0 ? (
        <DataValue> &mdash; </DataValue>
      ) : data[each] !== null ? (
        <DataValue className="mt0">
          {"$" +
            Number(data[each]).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}
        </DataValue>
      ) : (
        <DataValue> &mdash; </DataValue>
      )}
    </Col>
  );
}

export function renderFixGrid1({ data, each, label, mtop }) {
  return (
    <Col lg={6} md={12} className={mtop === true ? "mt1" : "mt0"}  data-test="container">
      <DataHeading className="mt-20">{label}</DataHeading>
      {data[each] === "" || data[each] === null ? (
        <DataValue> &mdash; </DataValue>
      ) : (
        <DataValue className="mt0">
          {each === "status.extDescription"
            ? data.status.extDescription
            : data[each] === "SHARE"
            ? "Units"
            : typeof data[each] === "string"
            ? data[each].charAt(0).toUpperCase() +
              data[each].slice(1).toLowerCase()
            : data[each]}
        </DataValue>
      )}
    </Col>
  );
}
